<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard>
          <v-layout justify-start align-content-start row wrap>
            <v-flex xs12>
              <h4>Predefined Messages</h4>
            </v-flex>
            <v-flex xs12>
              <v-layout style="width: 100%" justify-end>
                <v-btn
                  @click="dialog=true"
                  dark
                  color="green lighten-2"
                  small
                  class="text-none"
                >Add Message</v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-row align-center>
                <v-data-table
                  disable-pagination
                  style="width: 100%"
                  :headers="headers"
                  :items="bookingMessages"
                  hide-default-footer
                >
                  <template v-slot:item="props">
                    <tr>
                      <td style="width:10%;">
                        <p>{{props.item.id}}</p>
                      </td>
                      <td style="width:70%;">
                        <p>{{props.item.message}}</p>
                      </td>
                      <td style="width:20%;">
                        <v-flex py-1>
                          <v-row>
                            <v-flex shrink pr-3>
                              <v-btn
                                @click="editMessage = JSON.parse(JSON.stringify(props.item)); editDialog = true;"
                                small
                                class="text-none"
                              >Update</v-btn>
                            </v-flex>
                            <v-btn
                              @click="editMessage = JSON.parse(JSON.stringify(props.item)); deleteDialog = true;"
                              dark
                              small
                              class="text-none"
                              color="red lighten-2"
                            >Delete</v-btn>
                          </v-row>
                        </v-flex>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-row>
            </v-flex>
          </v-layout>
        </SimpleCard>
      </v-flex>
    </v-layout>
    <v-dialog persistent v-model="dialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Create Message</span>
        </v-card-title>
        <v-layout column px-4>
          <v-textarea :count="450" maxlength="450" v-model="message" placeholder="Message"></v-textarea>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat text @click="dialog = false">Cancel</v-btn>
          <v-btn flat text @click="create()">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-if="editMessage.id != null" v-model="editDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Message</span>
        </v-card-title>
        <v-layout column px-4>
          <v-textarea
            :count="450"
            maxlength="450"
            v-model="editMessage.message"
            placeholder="Message"
          ></v-textarea>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat text @click="editDialog = false">Cancel</v-btn>
          <v-btn flat text @click="update()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-if="editMessage.id != null" v-model="deleteDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Delete Message</span>
        </v-card-title>
        <v-layout column px-4>
          <p>{{editMessage.message}}</p>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn flat text @click="remove()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import qs from "qs";

export default {
  name: "predefined_messages",
  components: {
    Overview,
    SimpleCard
  },
  data: function() {
    return {
      loading: false,
      dialog: false,
      editDialog: false,
      deleteDialog: false,
      message: "",
      bookingMessages: [],
      editMessage: {},
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "Message",
          align: "left",
          sortable: false,
          value: "message"
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
          value: "actions"
        }
      ]
    };
  },
  mounted: async function() {
    this.get();
  },
  methods: {
    get: function(p) {
      this.loading = true;

      var url = `${this.$store.state.apiUrl}/predefined_messages/all`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            vm.bookingMessages = res.data.booking_messages;
          } else {
            alert("Failed to get settings");
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
          console.error(err);
        });
    },
    create: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/predefined_messages/create?message=${this.message}`;

      var vm = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            vm.get();
            vm.dialog = false;
          } else {
            alert("Failed to add predefined message: " + res.data.error);
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
        });
    },
    update: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/predefined_messages/update/${this.editMessage.id}?message=${this.editMessage.message}`;

      var vm = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            vm.get();
            vm.editDialog = false;
          } else {
            alert("Failed to update predefined message: " + res.data.error);
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
        });
    },
    remove: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/predefined_messages/delete/${this.editMessage.id}`;

      var vm = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            vm.get();
            vm.deleteDialog = false;
          } else {
            alert("Failed to delete predefined message: " + res.data.error);
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
        });
    }
  }
};
</script>
